import React from 'react';
import UserModerationPanel from '../../components/UserModerationPanel';

const UserModerationPage = () => (
	<UserModerationPanel />
);

export default UserModerationPage;
